import { render, staticRenderFns } from "./ImportValidationSummary.vue?vue&type=template&id=5bbd2bf5&scoped=true"
import script from "./ImportValidationSummary.vue?vue&type=script&lang=js"
export * from "./ImportValidationSummary.vue?vue&type=script&lang=js"
import style0 from "./ImportValidationSummary.vue?vue&type=style&index=0&id=5bbd2bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd2bf5",
  null
  
)

export default component.exports